import { MountLocationType } from '@amzn/intro-widgets-api'
import { Theme } from '@amzn/storm-ui'

const colorVariant = {
  palette: {
    ccxEmptyGrey: '#F2F4F6',
    ccxBorderGrey: '#D9DEE4',
    ccxToggleWhite: '#FBFBFC',
    ccxTextGreyOne: '#626D7B',
    ccxTextGreyTwo: '#354152',
    ccxTextGreyThree: '#656D78',
    ccxDividerGrey: '#CED3DC',
  },
}

// tooltip: need to override the height of Popover content, otherwise it'll easily overflow due to the height of image
// tooltip: 378px width: 26px left margin + 300px image size + 20px image white border + 4px image grey border + 28px right margin
export function customizeTheme(theme: Theme, mountLocation?: MountLocationType) {
  return {
    ...theme,
    anchoredAlert: {
      ...theme.anchoredAlert,
      zIndex: mountLocation === MountLocationType.MODAL ? '800' : '199',
    },
    tooltip: {
      ...theme.tooltip,
      maxHeight: 'unset',
      maxWidth: '378px',
    },
    popover: {
      ...theme.popover,
      zIndex: mountLocation === MountLocationType.MODAL ? 800 : 599,
    },
    palette: {
      ...theme.palette,
      ...colorVariant.palette,
    },
    modal: {
      ...theme.modal,
      zIndex: 799,
    },
  } as Theme
}

export type CustomizedColorVariant = typeof colorVariant
